/**
 * 词条的使用端：用户端（apps/web 与 /api/v1）与后台（apps/admin）。
 *
 * 用户端不得出现内部运营信息（TECH-BRIEF §0.3、spec-core §0.1），因此后台词条不进用户端的内置种子与
 * `GET /api/v1/i18n/:lang`。约定（D-P0-06-03）：
 * - 命名空间（= 种子文件名 = A45 词条的「所属模块」）为 `admin` 或以 `-admin` 结尾的属于后台；
 * - 员工邮件模板 `notify.staff.*`（spec-core §4.3，不进用户站内）属于后台，种子放在后台命名空间 `notify-admin`
 *   （前缀判断保留，A45 中旧数据或误填模块时仍不进用户端）；
 * - 其余属于用户端。用户不可见的错误码文案由服务端另按错误码登记表过滤（kernel i18n）。
 *
 * 另有"服务端渲染"命名空间（SERVER_RENDERED_NAMESPACES）：通知模板 `notify` 只由服务端渲染（站内、Web Push、邮件、LINE 的文案都在
 * 服务端按用户语言生成），用户端页面不使用，因此不打进 apps/web 的内置种子（构建产物里也就没有通知模板与事件 code）。
 */

export type Surface = 'user' | 'admin';

/** 后台命名空间：`admin` 与 `*-admin`。 */
export function isAdminNamespace(namespace: string): boolean {
  return namespace === 'admin' || namespace.endsWith('-admin');
}

/** 服务端渲染的命名空间：种子只供服务端（kernel i18n 读取全部种子文件）与后台，用户端内置种子不收录（文案仍面向用户）。 */
export const SERVER_RENDERED_NAMESPACES: readonly string[] = ['notify'];

export function isServerRenderedNamespace(namespace: string): boolean {
  return SERVER_RENDERED_NAMESPACES.includes(namespace);
}

/** 员工邮件模板的 key 前缀（spec-core §4.3：staff.activation 等，模板 key 为 notify.<code>.<channel>.<field>）。 */
export const STAFF_TEMPLATE_KEY_PREFIX = 'notify.staff.';

/**
 * 不依赖错误码登记表的判断：该命名空间下的该 key 是否面向用户（`GET /api/v1/i18n/:lang` 与缺译曝光计数）。
 * 通知模板面向用户（由服务端渲染后送达），这里返回 true；它们只是不打进用户端内置种子（bundled-user.ts 的 glob 排除）。
 */
export function isUserSurfaceEntry(namespace: string, key: string): boolean {
  if (isAdminNamespace(namespace)) return false;
  if (key.startsWith(STAFF_TEMPLATE_KEY_PREFIX)) return false;
  return true;
}
